import router from './router'
import savePoint from './components/use/savePoint'

const restore = () => {
  return router.push(savePoint().getSavePoint().value)
}

export { restore }
